'use client';

import { Text } from '@northladder/i18n';
import {
  ButtonV1,
  AssessmentInitiationAnimation,
} from '@northladder/design-system';

import { translations } from '../../../translations';

import { useRouteURL } from '../../hooks';

/**
 * -----------------------------------------------------------------------------
 * Creates functionality for selecting, uploading and previewing the uploaded
 * image.
 */
export function InitiateAssessment() {
  const { navigateToRoute, resetNavPath } = useRouteURL();

  const handleStartAssessment = () => {
    navigateToRoute('assess-black-screen', 'push');
  };

  const handleRestartAssessment = () => {
    resetNavPath('push');
  };

  return (
    <main className="flex min-h-[calc(100vh-230px)] items-center justify-center">
      <div className="mx-auto my-auto max-w-4xl px-4 pb-16 text-center sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-sm flex-col items-center py-8 md:max-w-2xl">
          <AssessmentInitiationAnimation
            className="
              my-10 h-40 w-full object-contain object-center sm:h-60
            "
          />
          <h1 className="text-md text-primary-700 w-2/3 font-normal tracking-tight">
            <Text text={translations.initiate.title} />
          </h1>
          <p className="text-primary-900 mt-4 hidden w-2/3 max-w-xl text-sm  font-light ">
            <Text text={translations.initiate.subTitle} />
          </p>
        </div>

        <div className="flex w-full justify-end">
          <ButtonV1
            className="mx-auto my-4 w-auto  px-16"
            isEnabled
            isLoading={false}
            label={translations.initiate.start}
            onClick={handleStartAssessment}
            type="button"
          />
        </div>
        <button
          className="form-link-action ms-2"
          onClick={handleRestartAssessment}
          type="button"
        >
          <Text text={translations.initiate.restartAssessment} />
        </button>
      </div>
    </main>
  );
}
